module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion_m_en.b293aeabd11a8db1b2dc8271106b45da.png";